"use client";
import { BlogPost } from "../data/posts/types";
import Content from "./content";

export default function Post({ post }: { post: BlogPost }) {
  return (
    <div className="w-full max-w-4xl mx-auto px-6 pt-16 pb-24 overflow-x-hidden">
      <header className="mb-12">
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-medium text-chocolate mb-6 leading-tight">
          {post.title}
        </h1>
        <div className="flex flex-row items-center gap-2 mb-8 font-sans text-xs font-semibold text-teal uppercase tracking-widest opacity-80">
          {post.author && (
            <span>{post.author.name}</span>
          )}
          {post.author && <span className="opacity-50">&bull;</span>}
          <div>
            {new Date(post.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </div>
        </div>
        {post.image && (
          <div className="w-full mb-8 rounded-xl overflow-hidden">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-auto block object-cover"
              style={{ maxHeight: "400px" }}
              loading="eager"
            />
          </div>
        )}
      </header>

      <Content content={post.content} />
    </div>
  );
}
